import axiosInstance from './axiosInstance';
import { API_CONFIG, getCategoryUrl } from '../config/apiConfig';
import { compressImageFile } from '../utils/compressImage';

export const getAllCategories = async () => {
  const response = await axiosInstance.post(
    getCategoryUrl(API_CONFIG.ENDPOINTS.CATEGORY.GET_ALL)
  );
  return response.data;
};

export async function addCategory(category: { CategoryName: string; CategoryDescription?: string; ImageUrl?: string; DisplayOrder?: number }) {
  const response = await axiosInstance.post(
    getCategoryUrl(API_CONFIG.ENDPOINTS.CATEGORY.CREATE),
    category
  );
  return response.data;
}

export async function updateCategory(category: { CategoryId: number; CategoryName: string; CategoryDescription?: string; ImageUrl?: string; DisplayOrder?: number }) {
  const response = await axiosInstance.put(
    getCategoryUrl(API_CONFIG.ENDPOINTS.CATEGORY.UPDATE),
    category
  );
  return response.data;
}

export async function deleteCategory(categoryId: number) {
  const response = await axiosInstance.delete(
    getCategoryUrl(API_CONFIG.ENDPOINTS.CATEGORY.DELETE),
    { params: { categoryId } }
  );
  return response.data;
}

export async function uploadCategoryImage(file: File) {
  const compressed = await compressImageFile(file);
  const formData = new FormData();
  formData.append('file', compressed);
  const response = await axiosInstance.post(
    getCategoryUrl('/UploadImage'),
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return response.data as { path: string };
}